import React, { FC, MouseEventHandler } from 'react';



type Itext = {
    text?: string;
    onClick?: MouseEventHandler<HTMLDivElement>;
    disabled?: any;
    img?: string;
    loading?: 'pending' | 'succeeded' | 'failed' | 'idle';
}

const ExportBtn:FC<Itext> = ({text, onClick, img}) => {
  return (
    <div className='bg-bgR text-xs lg:text-sm flex items-center gap-3 py-2 px-4 rounded-3xl text-bgPurple border-[1px] cursor-pointer' onClick={onClick}>
        <img src={img ? img : "/export.svg"} alt="" className="h-4 w-4" />
        <span className="">{text}</span>
    </div>
  )
}



export const AuthBtn:FC<Itext> = ({text, disabled, onClick, loading}) => {
    return(
        <div 
            onClick={onClick}
            className={`flex items-center justify-center gap-1 w-max ${disabled ? 'bg-[#3b353b38] cursor-not-allowed': ' bg-bgPurple'}  text-bgWhite rounded-3xl py-2 px-7  ${loading === 'pending' ? 'cursor-not-allowed': 'cursor-pointer'}`}>
            <span className="text-bgWhite text-sm text-center">{text}</span>
    
            {loading === 'pending' ? 
            <svg className="animate-spin h-4 w-4 rounded-full mr-3 bg-white text-white" viewBox="0 0 24 24"></svg>: 
            <img src="/autharr.svg" alt="" className="flex my-auto" />}
        </div>
    )
}


export const BackBtn:FC<Itext> = ({text, onClick}) => {
    return(
        <div onClick={onClick} className="flex items-center gap-2 bg-bgWhite text-bgPurple rounded-3xl py-3 px-7 cursor-pointer">
            <img src="/arrowleft.svg" alt="" className="" />
            <span className="text-bgPurple text-sm">{text}</span>
        </div>
    )
}

export default ExportBtn;
